import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import './subCategory.css';
class SubCategoryItem extends Component{
  getImageId = (url) =>{
    return url.substring(url.lastIndexOf('/')+1);
  }

  getResizeImage = (url, w, h) =>{
    const host = '//d3r3r4tgtn0hwd.cloudfront.net/'
    //return `${host}${w}x${h}/${this.getImageId(url)}`; disable size because resize function not working now
    return `${host}${this.getImageId(url)}`;
  }
  handleClick = () =>{

    window.href.location = `/subcategory/category/?category=${this.props.catename}&subcategory=${this.props.info.name}`;
  }
  render() {
    return(
      <div className="catagoryItem col-md-3 col-sm-6 col-xs-12 category-alignment">
        <Link className="catagoryItemLink" to={`/subcategory/category/${this.props.info.name}/${this.props.catename}`}>
          <div className="catagoryItemImgWrapper">
            <img src={this.getResizeImage(this.props.info.imageURL, '1200', '1800')} alt="{this.props.info.name}" className="category-image" />
          </div>
            <span className="catagoryCaption">
              <span className="catagoryCaptionDec">{this.props.info.name}</span>
            </span>
        </Link>
      </div>
    );
  }
 
}

export default SubCategoryItem;



// WEBPACK FOOTER //
// ./src/components/subcategories/subCategoryItem.js